// extracted by mini-css-extract-plugin
export default {"appLayout":"AppLayout_appLayout__wbyZ5","content":"AppLayout_content__mtxDa"};